import _extends from "@babel/runtime/helpers/extends";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import HttpClient from '@adsk/docs-http-client';
import { getRequestId } from '../utils/commons';

/**
 * A basic http service implement with axios to handle send / cancel request.
 */
var Service = /*#__PURE__*/function (_HttpClient) {
  /**
   * @param sdkConfig - the sdk options to initialize http
   */
  function Service(sdkConfig) {
    _classCallCheck(this, Service);
    var config = _extends({
      headers: _extends({
        'Content-Type': 'application/json;charset=UTF-8'
      }, sdkConfig.headers),
      getRequestId: getRequestId
    }, sdkConfig);
    return _callSuper(this, Service, [config]);
  }
  _inherits(Service, _HttpClient);
  return _createClass(Service);
}(HttpClient);
export { Service as default };